export enum CurrencySymbolEnum {
  USD = '$',
  EUR = '€',
}
